export const EIXOS = Object.freeze([
  { id: 'cognitivo', nome: 'Cognitivo' },
  { id: 'academico', nome: 'Acadêmico' },
  { id: 'psicomotor', nome: 'Psicomotor' },
  { id: 'social', nome: 'Social e emocional' },
]);

export const SKILLS = Object.freeze([
  { id: 'cog_atencao', eixo: 'cognitivo', nome: 'Atenção sustentada', descricao: 'Mantém foco em uma tarefa por tempo progressivo, com retirada gradual de apoio.' },
  { id: 'cog_memoria', eixo: 'cognitivo', nome: 'Memória de trabalho', descricao: 'Retém e manipula informações curtas durante uma atividade.' },
  { id: 'cog_discriminacao', eixo: 'cognitivo', nome: 'Discriminação visual/auditiva', descricao: 'Diferencia estímulos, figuras, sons, objetos e padrões.' },
  { id: 'cog_raciocinio', eixo: 'cognitivo', nome: 'Raciocínio e resolução de problemas', descricao: 'Organiza sequências, compara alternativas e resolve situações simples.' },
  { id: 'cog_funcoes_exec', eixo: 'cognitivo', nome: 'Funções executivas', descricao: 'Planeja, inibe impulsos, monitora ações e alterna estratégias.' },

  { id: 'aca_consciencia_fonologica', eixo: 'academico', nome: 'Consciência fonológica', descricao: 'Percebe sons iniciais, rimas, sílabas e unidades sonoras da fala.' },
  { id: 'aca_leitura', eixo: 'academico', nome: 'Leitura', descricao: 'Reconhece letras, palavras funcionais e sentidos em textos adequados.' },
  { id: 'aca_escrita', eixo: 'academico', nome: 'Escrita', descricao: 'Registra traçados, letras, palavras e ideias com apoio progressivo.' },
  { id: 'aca_matematica', eixo: 'academico', nome: 'Matemática', descricao: 'Compara quantidades, conta, opera e resolve situações do cotidiano.' },

  { id: 'psi_coordenacao_fina', eixo: 'psicomotor', nome: 'Coordenação motora fina', descricao: 'Controla pinça, preensão, encaixe, recorte, traçado e manipulação fina.' },
  { id: 'psi_coordenacao_ampla', eixo: 'psicomotor', nome: 'Coordenação motora ampla', descricao: 'Executa deslocamentos, saltos, arremessos e movimentos corporais amplos.' },
  { id: 'psi_oculomanual', eixo: 'psicomotor', nome: 'Coordenação óculo-manual', descricao: 'Coordena olhar, alcance, apontar, encaixar, lançar e receber objetos.' },
  { id: 'psi_equilibrio', eixo: 'psicomotor', nome: 'Equilíbrio e postura', descricao: 'Mantém postura, equilíbrio estático/dinâmico e segurança em circuitos.' },
  { id: 'psi_esquema_corporal', eixo: 'psicomotor', nome: 'Esquema corporal e lateralidade', descricao: 'Reconhece partes do corpo, posições, direção e lateralidade funcional.' },

  { id: 'soc_interacao', eixo: 'social', nome: 'Interação social e turnos', descricao: 'Participa de trocas sociais, espera, compartilha e respeita turnos.' },
  { id: 'soc_comunicacao', eixo: 'social', nome: 'Comunicação funcional', descricao: 'Expressa pedidos, escolhas, recusas, comentários e necessidades.' },
  { id: 'soc_autorregulacao', eixo: 'social', nome: 'Autorregulação', descricao: 'Identifica estados emocionais e usa estratégias de retorno à calma.' },
  { id: 'soc_autonomia', eixo: 'social', nome: 'Autonomia e vida diária', descricao: 'Realiza rotinas funcionais com independência progressiva.' },
]);

export const SKILL_IDS = Object.freeze(SKILLS.map((skill) => skill.id));
export const SKILL_LABEL = Object.freeze(Object.fromEntries(SKILLS.map((skill) => [skill.id, skill.nome])));
export const SKILL_EIXO = Object.freeze(Object.fromEntries(SKILLS.map((skill) => [skill.id, skill.eixo])));
export const SKILLS_BY_EIXO = Object.freeze(Object.fromEntries(EIXOS.map((eixo) => [eixo.id, SKILLS.filter((skill) => skill.eixo === eixo.id)])));

export function getSkillLabel(id) {
  return SKILL_LABEL[id] || String(id || '').replaceAll('_', ' ');
}

export function getSkillEixo(id) {
  return SKILL_EIXO[id] || 'geral';
}

export function getEvaluationTaxonomy() {
  return EIXOS.map((eixo) => ({
    ...eixo,
    habilidades: SKILLS_BY_EIXO[eixo.id] || [],
  }));
}
